export default "__VITE_ASSET__Bupn5$6G__"